import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27fb30f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Matnyttig Information om Tjeckien", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Valuta & Betalning:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Språk och Engelska:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Kulturella Egenheter:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Introduktion till Staden", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Transport:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Boende:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Stadsdelar", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Mala Strana:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Stare Mesto (Gamla Stan):", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Sevärdheter", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Pragborgen:"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En av de största slotten i världen med fantastisk utsikt över staden. Ta gärna en promenad genom The Royal Garden bort till Hanau Pavilion där du kan njuta av en fika eller en öl till utsikten av Karlsbron. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Karlbron:"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En ikonisk bro med statyer och underhållande gatumusikanter. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Astronomiska uret:"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Fascinerande urverk vid Gamla Stans torg. ")
  ])
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Mat och Dryck", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Traditionell Tjeckisk Mat:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Svíčková na Smetaně:"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En kär favorit, detta är marinerad rostbiff serverad med grädde och tranbärssås. En smakrik och mustig rätt. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Guláš:"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En mustig gryta, ofta tillagad med nötkött och kryddad med paprika, serveras med bröd eller potatis. En värmande klassiker. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Knedlíky:"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En sorts dumplings, ofta serverad som sidorätt. Kan vara söta eller salta och passar perfekt med grytor och såser. ")
  ])
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Sötsaker och Bakverk:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Trdelník:"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En populär gatukost bestående av ett kanel- och sockeröverdraget bakverk, grillas över öppen eld. Perfekt för den sötsugne resenären. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Medovník:"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En honungskaka med lager av kräm, valnötter och russin. En perfekt sötsak att avsluta din måltid med. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Palačinky:"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Tjeckiska crêpes, fyllda med sylt, frukt eller nötkräm. Ett fantastiskt mellanmål eller dessertalternativ. ")
  ])
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Drycker:", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Pilsner Urquell:"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En av världens mest berömda öl, född i Plzeň (Pilsen), är en uppfriskande pilsner med en unik smakprofil. Att få sig en öl serverad är trevligt, men ta chansen att själv agera bartender för en stund med "),
    /*#__PURE__*/_createElementVNode("strong", null, "öltapp vid bordet"),
    /*#__PURE__*/_createTextVNode(". På "),
    /*#__PURE__*/_createElementVNode("i", null, " The Pub Praha 1"),
    /*#__PURE__*/_createTextVNode(" har de installerat en tapp vid varje bord. Tappa upp helt efter behag och håll koll på hur mycket var och en vid bordet tappat genom att välja användare. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Becherovka:"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En kryddig örtlikör med en hemlig blandning av örter och kryddor. Dricks som aperitif eller efter en måltid. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Fernet Stock:"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En annan populär likör, känd för sin intensiva smak och används ofta som en digestif. ")
  ])
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Nattliv", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Mysiga Pubar för en Avslappnad Kväll", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "U Zlatého Tygra:"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En ikonisk tjeckisk pub med en lång historia. Här serveras öl direkt från fatet och atmosfären är genuint vänlig. Perfekt för en avslappnad kväll med vänner. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Lokál Dlouhááá:"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En modern pub som erbjuder klassiska tjeckiska ölsorter och en bred meny med lokala rätter. Här kan du njuta av traditionell atmosfär med en modern touch. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Vinograf Wine Bar:"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" För de som föredrar vin finns Vinograf, en charmig vinbar som erbjuder ett urval av utmärkta tjeckiska viner. Perfekt för en mer intim och avslappnad kväll. ")
  ])
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Livliga Nattklubbar för de Som Vill Dansa", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Karlovy Lázně:"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Europas största nattklubb, belägen i en historisk byggnad vid floden. Här finns flera dansgolv och musik för alla smaker. En måste-upplevelse för nattlivsentusiaster. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Cross Club:"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En unik och eklektisk nattklubb känd för sin industriella design och elektroniska musik. Perfekt för den som söker en annorlunda nattklubbsupplevelse. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Roxy:"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" En institution i Prags nattliv, Roxy erbjuder en mix av live-musik och DJ-spelningar. Här kan du uppleva en pulserande atmosfär och dansa natten lång. ")
  ])
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Upplevelser i Prag", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Petrinska utsiktstornet:"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Ta en promenad upp till Petřín och gå upp i det pittoreska utsiktstornet för en fantastisk panoramavy över Prag. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Vltava River Cruise:"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Hyr en kajak eller ta en båttur på floden Vltava för att se staden från ett annat perspektiv. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Cykeltur längs floden:"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Utforska cykelvägar längs floden Moldau och upplev Prag på två hjul. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Spökvandring i Gamla stan:"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Ge dig ut på en spännande spökvandring på kvällen och lyssna till berättelser om Prags hemsökta platser och historier. ")
  ])
], -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import CustomPic from "../../generics/CustomPic.vue";
import meta from "@/data/meta.json";
import Breadcrumbs from "@/components/generics/BreadCrumbs.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PragueGuide',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).PragueGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Prag",
      backgroundImageClass: "background-prague"
    }),
    _createVNode(ContentWrapper, { showBreadcrumbs: true }, {
      default: _withCtx(() => [
        _createVNode(Breadcrumbs),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextBlock, null, {
            default: _withCtx(() => [
              _createTextVNode(" Prag är inte bara en stad, det är en tidsresa. Utforska dess charm, njut av kulinariska läckerheter och upplev den unika atmosfären som bara Prag kan erbjuda. En resa som kommer fylla ditt hjärta och ditt fotoalbum. "),
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _createTextVNode(" Tjeckiska korun (CZK). Vanliga kort accepteras generellt, men kontanter rekommenderas för mindre ställen och på lokala kaféer. "),
              _hoisted_6,
              _hoisted_7,
              _createTextVNode(" Tjeckiska är det officiella språket, men engelska talas vanligtvis i turistområden och större städer. När du reser i Tjeckien är det användbart att känna till några grundläggande fraser för att underlätta kommunikationen. För att hälsa säger du \"Ahoj\" för hej eller \"Dobrý den\" för goddag. Om du behöver be om något använder du \"Prosím\" för snälla samt varsågod eller \"Omlouvám se\" för ursäkta mig. Att säga tack är viktigt, och du kan säga \"Děkuji\" (formellt) eller det mer vardagliga \"Díky\". Detta ger dig en grundläggande förmåga att kommunicera och visa respekt för den tjeckiska kulturen. "),
              _hoisted_8,
              _hoisted_9,
              _createTextVNode(" Respekt för äldre och sedvänjor är viktigt. Hälsa med en lätt nick och använd \"Prosím\" (snälla) och \"Děkuji\" (tack). "),
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _createTextVNode(" Prag, hjärtat av Tjeckien, lockar med sin rika historia, vackra arkitektur och charmiga atmosfär. Staden bjuder på en unik blandning av medeltida och modern kultur. "),
              _hoisted_13,
              _hoisted_14,
              _createTextVNode(" Ankomst via tågstationen Praha hlavní nádraží. Resor inom staden med tunnelbana och spårvagn är bekväma alternativ. "),
              _hoisted_15,
              _hoisted_16,
              _createTextVNode(" För en autentisk upplevelse, överväg att bo i Mala Strana eller Gamla Stan. Budgetalternativ finns runt Zizkov. "),
              _hoisted_17,
              _hoisted_18,
              _hoisted_19,
              _hoisted_20,
              _createTextVNode(),
              _hoisted_21,
              _createTextVNode(" Känd för sina pittoreska gränder och charmiga kaféer. Perfekt för romantiska promenader. "),
              _hoisted_22,
              _createTextVNode(),
              _hoisted_23,
              _createTextVNode(" Här hittar du den berömda Karlsbron och Astronomiska uret. Full av historia och kultur. "),
              _hoisted_24,
              _hoisted_25,
              _hoisted_26,
              _hoisted_27,
              _hoisted_28,
              _createTextVNode(" Tjeckien erbjuder en smakresa genom sina traditionella rätter och lokala delikatesser. Se till att smaka på olika specialiteter för att verkligen uppleva den autentiska tjeckiska matkulturen under din vistelse i Prag. "),
              _hoisted_29,
              _hoisted_30,
              _hoisted_31,
              _hoisted_32,
              _createTextVNode(" Tjeckien är känt för sin rika och hjärtliga matkultur, där traditionella rätter speglar landets historia och geografi. "),
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _createTextVNode(" Tillfredsställ ditt sötsug med några av Tjeckiens utsökta bakverk. "),
              _hoisted_36,
              _hoisted_37,
              _hoisted_38,
              _createTextVNode(" Utforska Tjeckiens dryckeskultur med deras kända öl och andra lokala favoriter. "),
              _hoisted_39,
              _hoisted_40,
              _createTextVNode(" Nattlivet i Prag är lika mångfacetterat som staden själv. Här finns något för alla, från pittoreska pubar till pulserande nattklubbar. Utforska stadens unika nattliv och låt dig svepas med i dess energi. Något vanligt förekommande bland alla hostel i stan är pubcrawls eller pubrundor. Det utlovas ofta gratis och obegränsat med dryck under några av rundans första timmar och därefter besök till flertalet klubbar. Var medveten om ni troligtvis kommer att hamna i en tämligen tråkig och något nedgången lokal och konsumera dryck som både är blaskig och smaklös. Klubbarna kommer mest vara små källarlokaler vars flesta besökare är pubrundedeltagare, förutom kanske den sista, vilken inte heller är något av Prags hetaste uteställen. Med det sagt så kan det fortfarande vara en helt fantastisk möjlighet att träffa nytt folk som också är på resa, men vänta er varken hög standard eller att få valuta för era pengar."),
              _hoisted_41,
              _hoisted_42,
              _hoisted_43,
              _hoisted_44,
              _hoisted_45,
              _hoisted_46,
              _hoisted_47,
              _createTextVNode(" Upptäck Prags charm bortom historiska platser och sevärdheter. Nedan hittar du några unika upplevelser som ger en extra dimension till din vistelse i staden. "),
              _hoisted_48
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})